import { inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SvcBulkGetResponse } from '../../shared/models';
import { environment } from '../../../environments/environment';

export abstract class BaseCrudService<T> {
  protected http = inject(HttpClient);
  protected abstract readonly endpoint: string;

  protected get baseUrl(): string {
    return `${environment.apiUrl}/${this.endpoint}`;
  }

  get(id: string): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/Get`, { params: { id } });
  }

  search(search = '', skip = 0, take = 50): Observable<SvcBulkGetResponse<T>> {
    const params = new HttpParams()
      .set('search', search)
      .set('skip', skip)
      .set('take', take);
    return this.http.get<SvcBulkGetResponse<T>>(`${this.baseUrl}/Search`, { params });
  }

  create(body: Partial<T>): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}/Post`, body);
  }

  update(body: T): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}/Put`, body);
  }

  delete(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.baseUrl}/Delete`, { params: { id } });
  }

  deleteMany(ids: string[]): Observable<boolean> {
    return this.http.delete<boolean>(`${this.baseUrl}/DeleteMany`, { body: ids });
  }
}
